export const AUTH_TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_EXPIRY_KEY = 'refresh_token_expires_at';

export const getAuthHeaders = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const setAuthHeaders = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const removeAuthHeaders = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_EXPIRY_KEY);
  try {
    localStorage.removeItem('okta_config');
  } catch (error) {
    console.warn('Failed to clear Okta config:', error);
  }
};

export const setRefreshTokenExpiry = (expiresAt) => {
  if (expiresAt) localStorage.setItem(REFRESH_TOKEN_EXPIRY_KEY, expiresAt);
};

export const getRefreshTokenExpiry = () =>
  localStorage.getItem(REFRESH_TOKEN_EXPIRY_KEY);

export const setCustomNaming = (user) => {
  user.organizations.map((o) =>
    localStorage.setItem(
      `${o.slug}_CUSTOM_NAMING_SETTING`,
      JSON.stringify(o.customNaming)
    )
  );
};

export const isSignedIn = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return typeof token === 'string' && token.length > 0;
};
